import { render, staticRenderFns } from "./FooterEn.vue?vue&type=template&id=6d941047&"
import script from "./FooterEn.vue?vue&type=script&lang=js&"
export * from "./FooterEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports